import React from 'react';
import MBCheckbox from 'components/Elements/MBCheckbox';
import * as Styles from './ProductCard.styles';

type CardSelectProps = {
  isSelected: boolean;
  isSelectboxDisabled: boolean;
  showAdvancedInfo: boolean;
  checkboxTooltipTitle?: string;
  handleSelectClicked: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export function CardSelect({
  isSelected,
  isSelectboxDisabled,
  showAdvancedInfo,
  checkboxTooltipTitle,
  handleSelectClicked,
}: CardSelectProps) {
  return (
    <Styles.CheckboxTooltip
      PopperProps={{ disablePortal: true }}
      title={checkboxTooltipTitle}
    >
      <Styles.SelectedIconContainer showAdvancedInfo={showAdvancedInfo}>
        <MBCheckbox
          size={26}
          onClick={handleSelectClicked}
          checked={isSelected}
          disabled={isSelectboxDisabled}
        />
      </Styles.SelectedIconContainer>
    </Styles.CheckboxTooltip>
  );
}
